import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Divider, Tooltip, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { isNotificationSliderOpened, setNotificationSliderVisibility } from "notification/tools/common"
import { navigate } from "page/tools/navigate"
import React from "react"
import { IMenuItem, MENU_ITEM_ID } from "ui/model"

interface IMenuItemProps {
  menu: IMenuItem
  isOpened: boolean
  isActive: boolean
  isFirst: boolean
  sx?: any
  onBackgroundClick?: (...arg: any) => any // used for preview
  onTextClick?: (...arg: any) => any // used for preview
}

export const MenuItem = React.memo(
  ({ menu, isOpened, isActive, isFirst, sx, onBackgroundClick, onTextClick }: IMenuItemProps) => {
    const isGroup: boolean = menu.hasOwnProperty("items")
    const onTextClickFn = onTextClick
      ? (event: any) => {
          event.stopPropagation()
          event.preventDefault()
          onTextClick(event)
        }
      : undefined
    return (
      <Tooltip title={isOpened ? "" : translate(menu.titleKey)} placement="right">
        <Box
          id={`${MENU_ITEM_ID}-${menu.titleKey}`}
          sx={{
            "position": "relative",
            "height": !isGroup || isOpened ? "2.5rem" : 0,
            "minHeight": !isGroup || isOpened ? "2rem" : 0,
            "mb": ".3rem",
            "display": "flex",
            "alignItems": "center",
            "justifyContent": isOpened ? "start" : "center",
            "cursor": !isActive && menu.pagePaths.length > 0 ? "pointer" : undefined,
            "pl": !isOpened ? undefined : !isGroup && isOpened ? "3rem" : ".9rem",
            "pr": isOpened ? ".9rem" : undefined,
            "borderRadius": ".25rem",
            "backgroundColor": theme => (isActive ? theme.palette.primary.main : "transparent"),
            "color": theme => (isActive ? theme.palette.specialText : theme.palette.text.primary),
            "transition": "all 300ms ease",
            "&:hover": {
              backgroundColor: theme =>
                isActive
                  ? theme.palette.primary.main
                  : menu.pagePaths.length > 0
                  ? theme.palette.background.default
                  : "transparent"
            },
            ...sx
          }}
          onClick={event => {
            if (onBackgroundClick) {
              onBackgroundClick(event)
              return
            }
            if (!isActive && menu.pagePaths.length > 0) {
              if (isNotificationSliderOpened()) {
                setNotificationSliderVisibility(false)
              }
              if (!menu.pathParams) {
                navigate(menu.pagePaths[0])
              } else {
                navigate({
                  path: menu.pagePaths[0],
                  pathParams: menu.pathParams
                })
              }
            }
          }}>
          {!isFirst && isGroup && <Divider sx={{ width: "100%", position: "absolute", top: 0, left: 0 }} />}
          {menu.icon && <FontAwesomeIcon icon={menu.icon} size="lg" onClick={onTextClickFn} />}
          {isOpened ? (
            <Typography
              id={`${MENU_ITEM_ID}-${menu.titleKey}.title`}
              sx={{
                ml: ".5rem",
                fontSize: isGroup ? "1.2rem" : ".9rem",
                fontWeight: isGroup || isActive ? 600 : undefined,
                overflow: "hidden",
                whiteSpace: "nowrap"
              }}
              onClick={onTextClickFn}>
              {translate(menu.titleKey)}
            </Typography>
          ) : null}
        </Box>
      </Tooltip>
    )
  }
)
